export default __webpack_public_path__ + "static/media/placeholder.944ce8e3.png";